import React, { FC, useMemo } from "react";

import SectionWithTitle from "src/components/SectionWithTitle";
import SchemaLink from "src/components/index/schemas/SchemaLink";
import { schemaPath } from "src/lib/schemaOrgUrl";
import { SchemaReference } from "src/lib/graphql/types";
import FormattedSchemaPath from "./FormattedSchemaPath";

const SchemaChildren: FC<{
  children?: SchemaReference[];
  isProperty: boolean;
}> = ({ children, isProperty }) => {
  const sortedChildren = useMemo(
    () =>
      [...(children ?? [])].sort((a, b) =>
        schemaPath(a).localeCompare(schemaPath(b))
      ),
    [children]
  );

  if (sortedChildren.length < 1) {
    return null;
  }

  return (
    <SectionWithTitle title={isProperty ? "Sub-properties" : "Children"}>
      <ul className="schema-children">
        {sortedChildren.map(({ name, namespace }) => (
          <li key={schemaPath({ name, namespace })}>
            <SchemaLink
              name={name}
              namespace={namespace}
              href={schemaPath({ name, namespace })}
            >
              <FormattedSchemaPath name={name} namespace={namespace} />
            </SchemaLink>
          </li>
        ))}
      </ul>
    </SectionWithTitle>
  );
};

export default SchemaChildren;
